import { render } from "./RegistrarClienteModal.vue?vue&type=template&id=0a88dc00&scoped=true"
import script from "./RegistrarClienteModal.vue?vue&type=script&lang=js"
export * from "./RegistrarClienteModal.vue?vue&type=script&lang=js"

import "./RegistrarClienteModal.vue?vue&type=style&index=0&id=0a88dc00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a88dc00"]])

export default __exports__